import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Alert } from "react-bootstrap";
import { GetUserCoins } from "../Database/Functions";

import "./UserPanel.scss";
import Icon from "../UI/Icon/Icon";
import IconList from "../UI/IconList/IconList";

export default (props) => {
  const [error, setError] = useState("");
  const [coins, setLoadedCoins] = useState();

  const [isLoading, setIsLoadingState] = useState();
  const { currentUser, isAdmin, getUserData } = useAuth();

  const userID = props.userID ? props.userID : currentUser.uid;

  //Load Perks
  useEffect(() => {
    setIsLoadingState(true);

    // TODO сделать авторизацию при запросах к бд
    GetUserCoins(userID)
      .then((items) => {
        // setIsLoadingState(false);
        setLoadedCoins(items.toString());
        setIsLoadingState(false);
      })
      .catch((e) => {
        console.log(e.message);
      });
  }, []);

  return (
    currentUser && (
      <div className="Header">
        {error && <Alert variant="danger">{error}</Alert>}

        <IconList layout="horizontal" align="center">
          <Icon
            image="baf"
            size="xl"
            title={isLoading ? "XX" : coins}
            className="Header__item Icon-list__item"
            imageClassName="Header__icon-image"
          />
          {userID != currentUser.uid && <b className="Icon-list__item">Просмотр</b>}
          {userID == currentUser.uid && isAdmin && <b className="Icon-list__item">Admin</b>}
        </IconList>
      </div>
    )
  );
}
